import React from "react";
import { NavLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import {
  HomeIcon,
  LargeDollarIcon,
  MenuIconRequests,
  MenuIconAccount,
} from "../../Media/Icon/Icons/Icons";
import tokens from "../../../shared/theme/tokens";
import { useNavItems, NavItem } from "./useNavItems";

const ICONS: Record<NavItem["key"], React.ReactNode> = {
  home: <HomeIcon />,
  rent: <LargeDollarIcon />,
  requests: <MenuIconRequests />,
  settings: <MenuIconAccount />,
};

/**
 * Fixed bottom tab bar for the authorized shell below the md breakpoint.
 * Successor to MainMenu's mobile mode (the dead earnings/payout active-class
 * logic was dropped); same four destinations via useNavItems.
 */
export const MobileTabBar = () => {
  const navItems = useNavItems();

  return (
    <Box
      component="nav"
      sx={{
        height: `${tokens.layout.mobileTabBarHeight}px`,
        flexShrink: 0,
        display: "flex",
        backgroundColor: tokens.colors.surface,
        borderTop: `1px solid ${tokens.colors.border}`,
        boxShadow: "0px -2px 10px rgba(24, 47, 51, 0.05)",
        pb: "env(safe-area-inset-bottom)",
      }}
    >
      {navItems.map((item) => (
        <Box
          key={item.key}
          component={NavLink}
          to={item.urlPath}
          aria-disabled={item.disabled}
          onClick={(e: React.MouseEvent) => item.disabled && e.preventDefault()}
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.5,
            color: tokens.colors.inkMuted,
            opacity: item.disabled ? 0.45 : 1,
            "& svg": { width: 22, height: 22 },
            "&.active": {
              color: tokens.colors.primaryDeep,
              "& p": { fontWeight: 600 },
            },
          }}
        >
          {ICONS[item.key]}
          <Typography
            component="p"
            sx={{ fontSize: 11.5, fontWeight: 500, color: "inherit" }}
          >
            {item.title}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
